import { createAsyncThunk } from "@reduxjs/toolkit";
import {
    getFinanzasKpis,
    getFinanzasEvolucion,
    getFinanzasGastosHolded,
    getFinanzasSaldos,
    getFinanzasFacturasPendientes,
    getFinanzasParciales,
    getFinanzasPaisesAnual,
    getFinanzasPaisesParcial,
    getFinanzasClientesAnual,
    getFinanzasClientesParcial,
    getFinanzasAgingCobros,
    getFinanzasDso,
    getFinanzasTicketMedioAnual,
    getFinanzasTicketMedioParcial,
    getFinanzasEficiencia,
} from '../../helpers/finanzasApi';

import { resolveErpIds } from '../filters/reducer';

const getFilters = (getState) => {
    const state = getState();
    return { empresaId: resolveErpIds(state), year: state.Filters.year };
};

export const getFinanzasKpisData = createAsyncThunk(
    "dashboardFinanzas/getKpis",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getFinanzasKpis(empresaId, year);
    }
);

export const getFinanzasEvolucionData = createAsyncThunk(
    "dashboardFinanzas/getEvolucion",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getFinanzasEvolucion(empresaId, year);
    }
);

export const getFinanzasGastosData = createAsyncThunk(
    "dashboardFinanzas/getGastos",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getFinanzasGastosHolded(empresaId, year);
    }
);

export const getFinanzasSaldosData = createAsyncThunk(
    "dashboardFinanzas/getSaldos",
    async (_, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getFinanzasSaldos(empresaId);
    }
);

export const getFinanzasFacturasPendientesData = createAsyncThunk(
    "dashboardFinanzas/getFacturasPendientes",
    async (_, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getFinanzasFacturasPendientes(empresaId);
    }
);

// Facturas sin cobrar filtradas por el mes seleccionado (vista mensual).
export const getFinanzasFacturasPendientesMesData = createAsyncThunk(
    "dashboardFinanzas/getFacturasPendientesMes",
    async (filtroParcial, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getFinanzasFacturasPendientes(empresaId, filtroParcial);
    }
);

export const getFinanzasParcialData = createAsyncThunk(
    "dashboardFinanzas/getParcial",
    async (filtroParcial, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getFinanzasParciales(empresaId, filtroParcial);
    }
);

export const getFinanzasPaisesAnualData = createAsyncThunk(
    "dashboardFinanzas/getPaisesAnual",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getFinanzasPaisesAnual(empresaId, year, 10);
    }
);

export const getFinanzasPaisesParcialData = createAsyncThunk(
    "dashboardFinanzas/getPaisesParcial",
    async (filtroParcial, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getFinanzasPaisesParcial(empresaId, filtroParcial, 5);
    }
);

export const getFinanzasClientesAnualData = createAsyncThunk(
    "dashboardFinanzas/getClientesAnual",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getFinanzasClientesAnual(empresaId, year, 10);
    }
);

export const getFinanzasClientesParcialData = createAsyncThunk(
    "dashboardFinanzas/getClientesParcial",
    async (filtroParcial, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getFinanzasClientesParcial(empresaId, filtroParcial, 5);
    }
);

export const getFinanzasAgingCobrosData = createAsyncThunk(
    "dashboardFinanzas/getAgingCobros",
    async (_, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getFinanzasAgingCobros(empresaId);
    }
);

export const getFinanzasDsoData = createAsyncThunk(
    "dashboardFinanzas/getDso",
    async (_, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getFinanzasDso(empresaId);
    }
);

export const getFinanzasTicketMedioAnualData = createAsyncThunk(
    "dashboardFinanzas/getTicketMedioAnual",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getFinanzasTicketMedioAnual(empresaId, year);
    }
);

export const getFinanzasTicketMedioParcialData = createAsyncThunk(
    "dashboardFinanzas/getTicketMedioParcial",
    async (filtroParcial, { getState }) => {
        const { empresaId } = getFilters(getState);
        return await getFinanzasTicketMedioParcial(empresaId, filtroParcial);
    }
);

export const getFinanzasEficienciaData = createAsyncThunk(
    "dashboardFinanzas/getEficiencia",
    async (_, { getState }) => {
        const { empresaId, year } = getFilters(getState);
        return await getFinanzasEficiencia(empresaId, year);
    }
);
